import { motion, AnimatePresence } from "framer-motion";

export const Detail = ({ n, title, text, testId }) => (
  <AnimatePresence mode="wait">
    <motion.div
      key={n + title}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -6 }}
      transition={{ duration: 0.35 }}
      className="border-t border-[#0D1B2A]/15 pt-5"
      data-testid={testId}
    >
      <p className="mono text-xs text-[#595959]">{n}</p>
      <p className="text-lg md:text-xl font-medium tracking-tight mt-2">{title}</p>
      <p className="body-copy mt-3">{text}</p>
    </motion.div>
  </AnimatePresence>
);
